/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { HeoTransactionNumber } from './HeoTransactionNumber';
import {
    HeoTransactionNumberFromJSON,
    HeoTransactionNumberFromJSONTyped,
    HeoTransactionNumberToJSON,
    HeoTransactionNumberToJSONTyped,
} from './HeoTransactionNumber';
import type { PaymentMethod } from './PaymentMethod';
import {
    PaymentMethodFromJSON,
    PaymentMethodFromJSONTyped,
    PaymentMethodToJSON,
    PaymentMethodToJSONTyped,
} from './PaymentMethod';

/**
 * 
 * @export
 * @interface InvoiceItemCsvExportSummary
 */
export interface InvoiceItemCsvExportSummary {
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemCsvExportSummary
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemCsvExportSummary
     */
    pricePerUnit: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemCsvExportSummary
     */
    discount: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemCsvExportSummary
     */
    discountedPricePerUnit: number;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    customerReference: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    customerItemReference: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    productNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    productName: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    productOriginCountry: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    productTariffNumber: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    productManufactur?: string;
    /**
     * 
     * @type {HeoTransactionNumber}
     * @memberof InvoiceItemCsvExportSummary
     */
    invoiceNumber: HeoTransactionNumber;
    /**
     * 
     * @type {number}
     * @memberof InvoiceItemCsvExportSummary
     */
    positionPrice: number;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceItemCsvExportSummary
     */
    shipped: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceItemCsvExportSummary
     */
    invoiceCanceled: boolean;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceItemCsvExportSummary
     */
    invoiceCreatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceItemCsvExportSummary
     */
    paymentDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof InvoiceItemCsvExportSummary
     */
    paymentDueDate?: Date;
    /**
     * 
     * @type {PaymentMethod}
     * @memberof InvoiceItemCsvExportSummary
     */
    paymentMethod: PaymentMethod;
    /**
     * 
     * @type {Address}
     * @memberof InvoiceItemCsvExportSummary
     */
    shippingAddress: Address;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    productGtin: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceItemCsvExportSummary
     */
    invoiceReference: string;
}



/**
 * Check if a given object implements the InvoiceItemCsvExportSummary interface.
 */
export function instanceOfInvoiceItemCsvExportSummary(value: object): value is InvoiceItemCsvExportSummary {
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('pricePerUnit' in value) || value['pricePerUnit'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountedPricePerUnit' in value) || value['discountedPricePerUnit'] === undefined) return false;
    if (!('customerReference' in value) || value['customerReference'] === undefined) return false;
    if (!('customerItemReference' in value) || value['customerItemReference'] === undefined) return false;
    if (!('productNumber' in value) || value['productNumber'] === undefined) return false;
    if (!('productName' in value) || value['productName'] === undefined) return false;
    if (!('productOriginCountry' in value) || value['productOriginCountry'] === undefined) return false;
    if (!('productTariffNumber' in value) || value['productTariffNumber'] === undefined) return false;
    if (!('invoiceNumber' in value) || value['invoiceNumber'] === undefined) return false;
    if (!('positionPrice' in value) || value['positionPrice'] === undefined) return false;
    if (!('shipped' in value) || value['shipped'] === undefined) return false;
    if (!('invoiceCanceled' in value) || value['invoiceCanceled'] === undefined) return false;
    if (!('invoiceCreatedAt' in value) || value['invoiceCreatedAt'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('shippingAddress' in value) || value['shippingAddress'] === undefined) return false;
    if (!('productGtin' in value) || value['productGtin'] === undefined) return false;
    if (!('invoiceReference' in value) || value['invoiceReference'] === undefined) return false;
    return true;
}

export function InvoiceItemCsvExportSummaryFromJSON(json: any): InvoiceItemCsvExportSummary {
    return InvoiceItemCsvExportSummaryFromJSONTyped(json, false);
}

export function InvoiceItemCsvExportSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceItemCsvExportSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'quantity': json['quantity'],
        'pricePerUnit': json['pricePerUnit'],
        'discount': json['discount'],
        'discountedPricePerUnit': json['discountedPricePerUnit'],
        'customerReference': json['customerReference'],
        'customerItemReference': json['customerItemReference'],
        'productNumber': json['productNumber'],
        'productName': json['productName'],
        'productOriginCountry': json['productOriginCountry'],
        'productTariffNumber': json['productTariffNumber'],
        'productManufactur': json['productManufactur'] == null ? undefined : json['productManufactur'],
        'invoiceNumber': HeoTransactionNumberFromJSON(json['invoiceNumber']),
        'positionPrice': json['positionPrice'],
        'shipped': json['shipped'],
        'invoiceCanceled': json['invoiceCanceled'],
        'invoiceCreatedAt': (new Date(json['invoiceCreatedAt'])),
        'paymentDate': json['paymentDate'] == null ? undefined : (new Date(json['paymentDate'])),
        'paymentDueDate': json['paymentDueDate'] == null ? undefined : (new Date(json['paymentDueDate'])),
        'paymentMethod': PaymentMethodFromJSON(json['paymentMethod']),
        'shippingAddress': AddressFromJSON(json['shippingAddress']),
        'productGtin': json['productGtin'],
        'invoiceReference': json['invoiceReference'],
    };
}

export function InvoiceItemCsvExportSummaryToJSON(json: any): InvoiceItemCsvExportSummary {
    return InvoiceItemCsvExportSummaryToJSONTyped(json, false);
}

export function InvoiceItemCsvExportSummaryToJSONTyped(value?: InvoiceItemCsvExportSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'quantity': value['quantity'],
        'pricePerUnit': value['pricePerUnit'],
        'discount': value['discount'],
        'discountedPricePerUnit': value['discountedPricePerUnit'],
        'customerReference': value['customerReference'],
        'customerItemReference': value['customerItemReference'],
        'productNumber': value['productNumber'],
        'productName': value['productName'],
        'productOriginCountry': value['productOriginCountry'],
        'productTariffNumber': value['productTariffNumber'],
        'productManufactur': value['productManufactur'],
        'invoiceNumber': HeoTransactionNumberToJSON(value['invoiceNumber']),
        'positionPrice': value['positionPrice'],
        'shipped': value['shipped'],
        'invoiceCanceled': value['invoiceCanceled'],
        'invoiceCreatedAt': value['invoiceCreatedAt'].toISOString(),
        'paymentDate': value['paymentDate'] == null ? value['paymentDate'] : value['paymentDate'].toISOString().substring(0,10),
        'paymentDueDate': value['paymentDueDate'] == null ? value['paymentDueDate'] : value['paymentDueDate'].toISOString().substring(0,10),
        'paymentMethod': PaymentMethodToJSON(value['paymentMethod']),
        'shippingAddress': AddressToJSON(value['shippingAddress']),
        'productGtin': value['productGtin'],
        'invoiceReference': value['invoiceReference'],
    };
}

